import { theme, darkTheme } from './theme/themeVariables';

const config = {
    darkMode: false,
    topMenu: false,
    rtl: false,
    theme,
    darkTheme,
};

export const DateAndTimeFormat = 'DD-MM-YYYY, h:mm A';
export const FixedContactAttributes = [
    {
        name: 'name',
        type: 'text',
        deletable: false,
        editable: false,
    },
    {
        name: 'phone',
        type: 'text',
        deletable: false,
        editable: false,
    },
    {
        name: 'email',
        type: 'text',
        deletable: false,
        editable: false,
    },
];


export const BroadcastEmailMergeTags = {
    contact: {
        name: 'Contact',
        mergeTags: {
            name: { name: 'Name', value: '{{contact.name}}' },
            email: { name: 'Email', value: '{{contact.email}}' },
            phone: { name: 'Phone', value: '{{contact.phone}}' },
        },
    },
    event: {
        name: 'Event',
        mergeTags: {
            name: { name: 'Name', value: '{{event.name}}' },
            description: { name: 'Description', value: '{{event.description}}' },
            location: { name: 'Location', value: '{{event.location}}' },
            joinLink: { name: 'Join link', value: '{{event.joinLink}}' },
            registrationLink: { name: 'Registration link', value: '{{event.registrationLink}}' },
            dateRange: { name: 'Date range', value: '{{event.dateRange}}' },
            startDate: { name: 'Start date', value: '{{event.startDate}}' },
            startTime: { name: 'Start time', value: '{{event.startTime}}' },
            endDate: { name: 'End date', value: '{{event.endDate}}' },
            endTime: { name: 'End time', value: '{{event.endTime}}' },
            scheduleText: { name: 'Schedule', value: '{{event.scheduleText}}' },
        },
    },
    organization: {
        name: 'Organization',
        mergeTags: {
            name: { name: 'Name', value: '{{organization.name}}' },
            website: { name: 'Website', value: '{{organization.website}}' },
            phone: { name: 'Phone', value: '{{organization.phone}}' },
            whatsappLink: { name: 'WhatsApp chat link', value: '{{organization.whatsappLink}}' },
            supportEmail: { name: 'Support email', value: '{{organization.supportEmail}}' },
            policyUrl: { name: 'Policy URL', value: '{{organization.policyUrl}}' },
        },
    },
    date: {
        name: 'Date & time',
        mergeTags: {
            today: { name: 'Today', value: '{{today}}' },
            year: { name: 'Year', value: '{{year}}' },
        },
    },
};

export const WhatsappBusinessVerticals = [
    {
        value: 'UNDEFINED',
        label: 'Undefined',
    },
    {
        value: 'OTHER',
        label: 'Other',
    },
    {
        value: 'AUTO',
        label: 'Auto',
    },
    {
        value: 'BEAUTY',
        label: 'Beauty',
    },
    {
        value: 'APPAREL',
        label: 'Apparel',
    },
    {
        value: 'EDU',
        label: 'Education',
    },
    {
        value: 'ENTERTAIN',
        label: 'Entertainment',
    },
    {
        value: 'EVENT_PLAN',
        label: 'Event Planning',
    },
    {
        value: 'FINANCE',
        label: 'Finance',
    },
    {
        value: 'GROCERY',
        label: 'Grocery',
    },
    {
        value: 'GOVT',
        label: 'Government',
    },
    {
        value: 'HOTEL',
        label: 'Hotel',
    },
    {
        value: 'HEALTH',
        label: 'Health',
    },
    {
        value: 'NONPROFIT',
        label: 'Non Profit',
    },
    {
        value: 'PROF_SERVICES',
        label: 'Professional Services',
    },
    {
        value: 'RETAIL',
        label: 'Retail',
    },
    {
        value: 'TRAVEL',
        label: 'Travel',
    },
    {
        value: 'RESTAURANT',
        label: 'Restaurant',
    },
    {
        value: 'NOT_A_BIZ',
        label: 'Not a Business',
    },
];


// Mirrors CATALOG_ITEM_FIELD_LIMITS on the backend — WhatsApp carousel cards cap the
// hydrated card body at 160 characters, so these fields have to stay short.
export const CatalogItemFieldLimits = {
    name: 60,
    caption: 60,
    agentNotes: 500,
    ctaLabel: 25,
    byteType: 40,
};

export const VoiceCallWebSocketEvents = {
    SESSION: {
        INCOMING: 'session:incoming',
        READY: 'session:ready',
        CLOSED: 'session:closed',
        HUMAN_TRANSFER_REQUEST: 'session:human_transfer_request',
    },
    HUMAN_AGENT: {
        ACCEPT: 'human_agent:accept_call',
        AUDIO_STREAM_PACKET: 'human_agent:audio_stream_packet',
        READY: 'human_agent:ready',
        CLOSED: 'human_agent:closed',
        SPEAKING: 'human_agent:speaking',
        LISTENING: 'human_agent:listening',
    },
    AI_AGENT: {
        AUDIO_STREAM_PACKET: 'ai_agent:audio_stream_packet',
        SPEAKING: 'ai_agent:speaking',
        THINKING: 'ai_agent:thinking',
        LISTENING: 'ai_agent:listening',
        READY: 'ai_agent:ready',
        HUMAN_TRANSFER_REQUEST: 'ai_agent:human_transfer_request',
        CLOSED: 'ai_agent:closed',
    },
    CONTACT: {
        AUDIO_STREAM_PACKET: 'contact:audio_stream_packet',
        READY: 'contact:ready',
        CLOSED: 'contact:closed',
        SPEAKING: 'contact:speaking',
        LISTENING: 'contact:listening',
    },
};

export default config;
